import { StyleSheet } from 'react-native';

/** ================================
*  定数
*  ================================*/

// スタイル定義
export const buttonColor = '#78ac44';

export const styles = StyleSheet.create({
  photo: {
    flex: 1,
  },
  fontSizeLL: {
    fontSize: 26,
  },
  fontSizeL: {
    fontSize: 20,
  },
  fontSizeM: {
    fontSize: 18,
  },
  fontSizeS: {
    fontSize: 12,
  },
  loading: {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    backgroundColor: '#ffffff',
    opacity: 0.6
  },
  badgeContainer: {
    marginLeft: 'auto',
    marginRight: 0,
    marginTop: 0,
    marginBottom: 0,
    backgroundColor: '#ed7d31',
    borderColor: '#ae5a21',
    minWidth: 20,
    height: 20,
    textAlign: 'center',
    borderRadius: 10,
  },
  badge: {
    color: '#ffffff',
    fontsize: 10,
  },
});

/**
 * 
 */
export const categoryItems = [
  { label: "開花", value: "flowering" },
  { label: "農薬散布", value: "pesticideSprayning" },
  { label: "摘果作業", value: "fruitsThinning" },
  { label: "交配", value: "mating" },
  { label: "収穫", value: "harvest" },
  { label: "その他", value: "others" }
];
export const categoryEventItems = [
  { label: "開花", value: "flowering" },
  { label: "農薬散布", value: "pesticideSprayning" },
  { label: "摘果作業", value: "fruitsThinning" },
  { label: "交配", value: "mating" },
  { label: "収穫", value: "harvest" },
  { label: "その他", value: "others" }
];

/**
 * Google MapのAPIキー
 */
export const googleMapsApiKey = "AIzaSyBYRgzw5ZwGruKOVylzf-9e0lhVU9d_5bk";

/**
 * 管理者のメールアドレス
 */
export const ADMIN_MAIL_ADDRESS = "test.admin@example.com";